/**
 * Survey permissions for SDA shell routes and sidebar (TenantContext / GET /auth).
 */
import { SURVEY_PERMISSIONS } from './permissions';

export const SDA_VIEW_SURVEY = 'view_survey';
export const SDA_CREATE_SURVEY = 'create_survey';
export const SDA_UPDATE_SURVEY = 'update_survey';
export const SDA_DELETE_SURVEY = 'delete_survey';
export const SDA_PUBLISH_SURVEY = 'publish_survey';
export const SDA_MANAGE_SURVEY = 'manage_survey';
export const SDA_VIEW_RESPONSES = 'view_responses';

export { SURVEY_PERMISSIONS };

/** Minimum permission to see Survey in the sidebar and open Overview. */
export const SURVEY_MODULE_PERMISSIONS = [SDA_VIEW_SURVEY];

/** Manage surveys list, create, edit, publish (create OR manage). */
export const SURVEY_MANAGE_ROUTE_PERMISSIONS = [SDA_CREATE_SURVEY, SDA_MANAGE_SURVEY];

/** Responses hub and per-survey response detail / export. */
export const SURVEY_RESPONSES_ROUTE_PERMISSIONS = [SDA_VIEW_RESPONSES];

export function canAccessSurveyModule(hasPermissionFn) {
  return hasPermissionFn(SDA_VIEW_SURVEY);
}

export function canAccessSurveyOverview(hasPermissionFn) {
  return hasPermissionFn(SDA_VIEW_SURVEY);
}

export function canAccessSurveyManage(hasPermissionFn) {
  return SURVEY_MANAGE_ROUTE_PERMISSIONS.some((code) => hasPermissionFn(code));
}

export function canAccessSurveyResponses(hasPermissionFn) {
  return hasPermissionFn(SDA_VIEW_RESPONSES);
}
